import { CustomerCalendarApi } from '../../CustomerCalendarApi';
import { CustomerBookingsQueryKey } from '../../queryKeys';
import { BookingRange } from '../../types';

export const CustomerBookingsStaleTimeInMilliseconds = 60 * 1000;

export function customerBookingsQueryKey(range: BookingRange | null) {
    return [CustomerBookingsQueryKey, range];
}

export function fetchCustomerBookings(range: BookingRange) {
    return CustomerCalendarApi.getBookings(range);
}
